<ng-container *ngIf="addToCartControl$ | async as operation" [xOperation]="operation">
  <ng-container *ngIf="productItem$ | async as productItem">
    <div
      class="view"
      [class.adding-to-cart]="operation.status === 'loading'"
      xObserveVisibility
      [emitVisibleOnce]="true"
      (isVisible)="isVisible($event, productItem)"
    >
      <a
        [id]="productItem.slug"
        [routerLink]="productItem.detailUrl"
        [queryParams]="getParams(productItem)"
        queryParamsHandling="merge"
        [xTrackingProductClick]="productItem"
      >
        <div class="media">
          <x-product-badges [badges]="productItem.badges"></x-product-badges>

          <div class="main-media" *ngIf="productItem.mainMedia as mainMedia">
            <x-product-media
              [media]="mainMedia"
              [width]="productItem.mediaSize"
              [height]="productItem.mediaSize"
              [blurHash]="productItem.blurHash"
            ></x-product-media>
          </div>

          <ng-container *ngIf="productItem.secondaryMedia as secondaryMedia">
            <div class="secondary-media">
              <x-product-media
                [media]="secondaryMedia"
                [width]="productItem.mediaSize"
                [height]="productItem.mediaSize"
              ></x-product-media>
            </div>
          </ng-container>

          <div
            class="item-quantity mat-display-2"
            *ngIf="productItem.variantAvailability.bagQuantity > 0"
          >
            {{ productItem.variantAvailability.bagQuantity }}
          </div>
        </div>
      </a>
      <div class="body-content">
        <header class="mat-body-2" [innerText]="productItem.title"></header>

        <div class="description mat-display-4" [xObserveHeight]="40" heightClass="two-lines">
          {{ productItem.description }}
        </div>

        <div class="footer">
          <div class="availability" *ngIf="!productItem.hasMultipleAvailableVariants">
            <x-availability
              [availabilityView]="productItem.variantAvailability.availabilityView"
              [availableRegions]="productItem.variantAvailability.availableRegions"
              [availableQuantity]="productItem.variantAvailability.maxAvailableQuantity"
            ></x-availability>
          </div>
          <div class="price mat-body-1">
            {{ productItem.hasMultipleAvailableVariants ? 'From ' : '' }}
            {{
              productItem.variantAvailability.price.amount
                | money: productItem.variantAvailability.price.currency
            }}
          </div>
        </div>

        <div class="actions">
          <div class="actions-container">
            <x-product-add-to-bag
              [productView]="productItem"
              [loading]="operation.status === 'loading'"
              (quantityChanged)="addToCart(productItem, $event)"
            ></x-product-add-to-bag>
            <x-wishlist-action
              [productId]="productItem.id"
              [context]="productItem.searchContext"
            ></x-wishlist-action>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <x-shop-error-operation *xOperationError="let error" [error]="error"></x-shop-error-operation>
</ng-container>
